import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosPrivate from 'config/axiosPrivate';

export const fetchAdminClientWebsiteDisplay = createAsyncThunk(
  'adminClientWebsiteDetails/fetchAdminClientWebsiteDisplay',
  async (urlSite, thunkAPI) => {
    try {
      if (!urlSite) return thunkAPI.rejectWithValue(404);
      const response = await axiosPrivate.get('/project/manager/website', {
        params: {
          url: urlSite,
        },
      });
      if (response.status === 200) {
        return response.data;
      }
      return thunkAPI.rejectWithValue(response.status);
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const fetchAdminClientWebsiteOrdersList = createAsyncThunk(
  'adminClientWebsiteDetails/fetchAdminClientWebsiteOrderList',
  async (id, thunkAPI) => {
    try {
      if (!id) return thunkAPI.rejectWithValue(404);
      const response = await axiosPrivate.get('/project/manager/commands/byWebsiteId/' + id);
      if (response.status === 200) {
        return response.data;
      }
      return thunkAPI.rejectWithValue(response.status);
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
